export default __webpack_public_path__ + "pl.472cede8.svg";